<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">{{ project.employerProjectNumber }} · Technik</p>
      <h2 class="presentation-page__title">
        Technische Daten — {{ project.employerProjectNumber }}
      </h2>
      <p class="presentation-page__text">Alle relevanten technischen Kennzahlen auf einen Blick.</p>
      <table class="presentation-page__data-table">
        <thead>
          <tr>
            <th>Information</th>
            <th>Daten</th>
            <th>Zusatzinfo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="metric in metrics" :key="metric.information">
            <td>{{ metric.information }}</td>
            <td class="presentation-page__data-table__cell--value">{{ metric.data }}</td>
            <td class="presentation-page__data-table__cell--note">{{ metric.note }}</td>
          </tr>
        </tbody>
      </table>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';
import { formatNumber, NUMBER_FORMAT } from '@/helpers/numberFormat';

export default {
  name: 'MasterPresentationPrintPage35',
  components: { PrintPageLandscape, PresentationPage },
  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {
    overallInstallationPower() {
      return formatNumber(
        this.project?.solarPlant?.solarPlantOverallPower,
        NUMBER_FORMAT.DECIMAL_TRIPLE
      );
    },

    areaInSquareMeters() {
      return formatNumber(
        this.project?.investmentDeductionAllowance?.areaInSquareMeters,
        NUMBER_FORMAT.DECIMAL
      );
    },

    specificAnnualYieldKwhPerKwp() {
      return formatNumber(
        this.project?.investmentDeductionAllowance?.specificAnnualYieldKwhPerKwp,
        NUMBER_FORMAT.DECIMAL
      );
    },

    feedInTariffGuaranteeCaseEurPerKwh() {
      return formatNumber(
        this.project?.investmentDeductionAllowance?.feedInTariffGuaranteeCaseEurPerKwh,
        NUMBER_FORMAT.DECIMAL_QUADRUPLE
      );
    },

    metrics() {
      return [
        { information: 'Fläche (m²)', data: `${this.areaInSquareMeters} m²`, note: 'PV-Fläche' },
        { information: 'Anlagentyp', data: 'Dachfläche', note: '' },
        // { information: 'Anschlussleistung (kW)', data: '315 kW', note: '' },
        {
          information: 'Gesamtinstallationsleistung',
          data: `${this.overallInstallationPower} kWp`,
          note: 'Nennleistung',
        },
        {
          information: 'Erwarteter Jahresertrag',
          data: `${this.specificAnnualYieldKwhPerKwp} kWh/kWp`,
          note: 'Spezifisch',
        },
        {
          information: 'Einspeisevergütung',
          data: `${this.feedInTariffGuaranteeCaseEurPerKwh} ct/kWh`,
          note: 'EEG-Tarif',
        },
        { information: 'Vertragslaufzeit', data: '20 Jahre', note: '+ 2 × 5 J. Verlängerung' },
      ];
    },
  },
};
</script>
